document.addEventListener('DOMContentLoaded', () => {

//   if (!document.body.classList.contains('theme-preview')) return;

  document.querySelectorAll('.product__accordion').forEach(accordion => {
    const content = accordion.querySelector('.accordion__content');
    console.log("content", content);
    

    if (!content) return;

    const text = content.textContent.replace(/\s+/g, '').trim();

    if (!text) {
      accordion.style.display = 'none';
    }
  });
});